import type {
  ContextualBlock,
  InteractiveScriptOptions,
  InteractiveScriptResult,
  ScriptLanguage,
} from '../script-generator/types.js';

export interface ScriptOutputOption {
  value: string;
  label: string;
}

export abstract class ScriptConverter {
  abstract readonly extensions: string[];

  /**
   * Join multiple block contents into one script body (no trailing newline).
   */
  abstract composeBlocks(blocks: string[]): string;

  /**
   * Output modes supported by this script type.
   * Example: bash -> standard + interactive, powershell -> standard
   */
  abstract getOutputOptions(): ScriptOutputOption[];

  /**
   * Detect the script language for grouped contextual blocks of this converter.
   */
  detectScriptLanguage(_blocks: ContextualBlock[]): ScriptLanguage {
    return 'other';
  }

  /**
   * Check whether this converter can generate interactive output for specific blocks.
   */
  supportsInteractiveBlocks(_blocks: ContextualBlock[]): boolean {
    return false;
  }

  /**
   * Generate an interactive script for this language.
   */
  generateInteractiveScript(
    _blocks: ContextualBlock[],
    _options: InteractiveScriptOptions = {}
  ): InteractiveScriptResult {
    return {
      success: false,
      error: 'Interactive mode is not supported for this script type.',
    };
  }

  supportsOutputMode(mode: string): boolean {
    return this.getOutputOptions().some(option => option.value === mode);
  }
}
